import CardProfile from "./CardProfile";
import "./css/Banner.css";
import { IconCode, IconGitCode, IconGitProjetos, IconLinkedIn } from "../../data/icons";

const uiText = {
  pt: {
    tag: "• Disponível para novos projetos",
    action: "Projetos",
    preview: "Olá, sou o",
    nome: "Tiago",
    sobrenome: "Lucas",
    descricao: "Desenvolvedor Full-Stack focado em construir aplicações web eficientes e criar experiências incríveis para o usuário."
  },
  en: {
    tag: "• Available for new projects",
    action: "Projects",
    preview: "Hello, I'm",
    nome: "Tiago",
    sobrenome: "Lucas",
    descricao: "Full-Stack Developer focused on building efficient web applications and creating amazing user experiences."
  }
};
function Banner({ language }) {
  const ui = uiText[language];
  return (
    <div className="banner">
      <div className="banner-content">
        <div className="card-banner">
          <span className="badge">{ui.tag}</span>

          <div className="title-group">
            <p className="intro">{ui.preview}</p>

            <h1>{ui.nome} <span>{ui.sobrenome}</span></h1>

            <div className="title-line" />
          </div>

          <p className="description">{ui.descricao}</p>

          {/* <div className="mini-stats">
            <div>
              <strong>React • Next.js</strong>
              <span>Front-end</span>
            </div>
            <div>
              <strong>C# .NET</strong>
              <span>Back-end</span>
            </div>
            <div>
              <strong>Python</strong>
              <span>Scripts</span>
            </div>
          </div> */}

          <div className="actions">
            {/* <a href="#projetos" className="btn-primary">
               <IconGitProjetos/> <spam style={{ marginLeft: '0.5rem' }}> {ui.action} </spam>
            </a> */}
            <a 
              href="https://www.github.com/tiagolucasoo" 
              className="btn-outline" 
              target="_blank" 
              rel="noopener noreferrer"
            >
            <IconGitCode/> <span style={{ marginLeft: '0.5rem' }}> GitHub </span>
            </a>
            <a 
              href="https://www.linkedin.com/in/tiagoollucas" 
              className="btn-outline" 
              target="_blank" 
              rel="noopener noreferrer"
            >
            <IconLinkedIn/> <span style={{ marginLeft: '0.5rem' }}> LinkedIn </span>
            </a>
          </div>
        </div>

        <div className="profile-side">
          <div className="profile-glow" />
          <CardProfile />
        </div>
      </div>

      <div className="wave-container">
        <svg
          className="waves"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>

          <g className="parallax">
            <use href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.3)" />
            <use href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
            <use href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.7)" />
            <use href="#gentle-wave" x="48" y="7" fill="#ffffff" />
          </g>
        </svg>
      </div>
    </div>
  );
}

export default Banner;
